module.exports = ".labelBold {\n  font-size: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/orders/orders-modal/orders-modal.component.scss
// module id = ./src/app/account-client/component/account-client-details/orders/orders-modal/orders-modal.component.scss
// module chunks = main